var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-pagination',_vm._g(_vm._b({staticClass:"custom-pagination",class:_vm.alignClass},'v-pagination',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }